import { createContext } from "react";

const ActiveStateContext = createContext(null);

export default ActiveStateContext;
